import type { PaletteRange } from '@mui/material/styles/createPalette'

//  Micro Green (Dark) - #08372e
//  Light Green (Fresh) - #98edb1
//  Grass Green (Medium) - #139051
//  Grey (Background) - #f6f6f6
//  Pale Blue (Accent) - #bee5eb
//  Soft Coral (Accent) - #fad1ba

export const microGreen = {
	50: '#deeeee',
	100: '#add6d3',
	200: '#7abcb6',
	300: '#47a29a',
	400: '#258f86',
	500: '#0a7c71',
	600: '#097066',
	700: '#096157',
	800: '#095248',
	900: '#08372e', // primary
	950: '#03201b',
} satisfies PaletteRange

export const lightGreen = {
	50: '#e6fbec',
	100: '#c2f4d0',
	200: '#98edb1', // primary
	300: '#6be593',
	400: '#47dc7d',
	500: '#12d467',
	600: '#00c35c',
	700: '#00b04f',
	800: '#009e44',
	900: '#007d30',
	950: '#00501f',
} satisfies PaletteRange

export const grassGreen = {
	50: '#e6f5ec',
	100: '#c2e7d0',
	200: '#9bd8b3',
	300: '#71c995',
	400: '#4ebd7f',
	500: '#25b168',
	600: '#1da25e',
	700: '#139052', // primary
	800: '#0a7f46',
	900: '#005f32',
	950: '#015028',
} satisfies PaletteRange

export const paleBlue = {
	50: '#e4f4f7',
	100: '#bee5eb', // primary
	200: '#92d5e0',
	300: '#67c6d5',
	400: '#4ebbcd',
	500: '#40b0c5',
	600: '#3ca0b3',
	700: '#368c9a',
	800: '#2f7883',
	900: '#235659',
	950: '#003239',
} satisfies PaletteRange

export const softCoral = {
	50: '#faebe6',
	100: '#fad1ba', // primary
	200: '#f8b58c',
	300: '#f6995b',
	400: '#f38531',
	500: '#f17300',
	600: '#e76d00',
	700: '#d96500',
	800: '#cc5e00',
	900: '#b55000',
	950: '#692700',
} satisfies PaletteRange

export const grey = {
	50: '#fafafa',
	100: '#f6f6f6', // primary
	200: '#f0f0f0',
	300: '#e2e2e2',
	400: '#c0c0c0',
	500: '#a1a1a1',
	600: '#787878',
	700: '#636363',
	800: '#444444',
	900: '#232323',
	950: '#161616',
} satisfies PaletteRange

export const california = {
	50: '#fffaea',
	100: '#fff3c6',
	200: '#ffe587',
	300: '#ffd049',
	400: '#ffbb1f',
	500: '#fb9c0c',
	600: '#de7101',
	700: '#b84d05',
	800: '#953b0b',
	900: '#7b310c',
	950: '#471701',
} satisfies PaletteRange

export const kepple = {
	50: '#f0fdfa',
	100: '#ccfbef',
	200: '#9af5e1',
	300: '#5fe9ce',
	400: '#2ed3b8',
	500: '#15b79f',
	600: '#0e9382',
	700: '#107569',
	800: '#115e56',
	900: '#134e48',
	950: '#042f2c',
} satisfies PaletteRange

export const nevada = {
	50: '#fbfcfe',
	100: '#f0f4f8',
	200: '#dde7ee',
	300: '#cdd7e1',
	400: '#838f9a',
	500: '#636b74',
	600: '#555e68',
	700: '#32383e',
	800: '#202427',
	900: '#121517',
	950: '#090a0b',
} satisfies PaletteRange

export const redOrange = {
	50: '#fef3f2',
	100: '#fee4e2',
	200: '#ffcdc9',
	300: '#fdaaa4',
	400: '#f97970',
	500: '#f04438',
	600: '#de3024',
	700: '#bb241a',
	800: '#9a221a',
	900: '#80231c',
	950: '#460d09',
} satisfies PaletteRange

export const shakespeare = {
	50: '#ecfdff',
	100: '#cff7fe',
	200: '#a4eefd',
	300: '#66e0fa',
	400: '#10bee8',
	500: '#04aad6',
	600: '#0787b3',
	700: '#0d6d91',
	800: '#145876',
	900: '#154964',
	950: '#082f44',
} satisfies PaletteRange

export const stormGrey = {
	50: '#f9fafb',
	100: '#f1f1f4',
	200: '#dcdfe4',
	300: '#b3b9c6',
	400: '#8a94a6',
	500: '#667085',
	600: '#565e73',
	700: '#434a60',
	800: '#313749',
	900: '#212636',
	950: '#121621',
} satisfies PaletteRange
